import { useHistory } from "react-router-dom";

// Components
import Welcome from "../Welcome/WelcomeContainer";
import { WelcomeNews } from "../WelcomeNews/WelcomeNews";
import WelcomeCarousel from "../WelcomeCarousel/WelcomeCarouselContainer";
import Block from "./Block";

const BlockContainer = (props) => {
    /**
     * Router Hooks
     */

    const history = useHistory();

    /**
     * End Hooks
     */

    return (
      <div>
          <Welcome {...props} history={history} />
          <WelcomeCarousel {...props} history={history} />
          <Block {...props} history={history} />
          <WelcomeNews {...props} history={history} />
      </div>

    );

};

export default BlockContainer;
